import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitolonavalacab() {



    const cardData = {




keyword: "Mumbai to Lonavala Cab",

headingDescription: "Shreesha Tours & Travels offers reliable, affordable, and comfortable Mumbai to Lonavala cab services for families, couples, corporate travelers, tourists, students, and weekend vacationers. We provide one-way cabs, round-trip taxi services, same-day return trips, airport transfers, and customized outstation travel packages with professional chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement and group size. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and enjoyable journey. Whether you are planning a romantic getaway, family holiday, corporate outing, monsoon road trip, sightseeing tour, or weekend escape, our Mumbai to Lonavala cab service provides clean vehicles, courteous drivers, and a comfortable travel experience through the scenic Mumbai–Pune Expressway and the beautiful Sahyadri hills.",

topPlaces: [
  {
    title: "Bhushi Dam",
    description: "Bhushi Dam is one of Lonavala's most popular tourist attractions, especially during the monsoon season. Visitors enjoy the overflowing water steps, cool weather, scenic surroundings, and picnic atmosphere. It is an ideal destination for families, groups of friends, and nature lovers looking to spend quality time outdoors."
  },
  {
    title: "Tiger Point",
    description: "Tiger Point is a famous viewpoint in Lonavala offering breathtaking panoramic views of deep valleys, mist-covered mountains, waterfalls, and lush greenery. The location is especially popular during sunrise, sunset, and the monsoon season, making it a favorite spot for photographers and couples."
  },
  {
    title: "Rajmachi Fort",
    description: "Rajmachi Fort is a historic hill fort surrounded by forests and scenic trekking trails. It attracts adventure enthusiasts, history lovers, and campers who wish to experience panoramic views of the Sahyadri mountain ranges and the rich Maratha heritage."
  },
  {
    title: "Karla Caves",
    description: "Karla Caves are ancient Buddhist rock-cut caves known for their magnificent architecture, detailed carvings, and centuries-old prayer halls. The caves are among Maharashtra's most significant archaeological attractions and are visited by tourists and history enthusiasts throughout the year."
  },
  {
    title: "Bhaja Caves",
    description: "Bhaja Caves are a group of ancient Buddhist caves featuring beautifully carved stupas, monasteries, and rock-cut sculptures. Located amidst green hills, they offer visitors a perfect blend of history, spirituality, and natural beauty."
  },
  {
    title: "Lohagad Fort",
    description: "Lohagad Fort is one of Maharashtra's most famous trekking destinations, known for its impressive fortifications, scenic mountain views, and historical significance. During the monsoon season, the surrounding greenery and mist make the trek even more memorable."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a peaceful destination near Lonavala, famous for lakeside camping, boating, photography, and spectacular sunset views. It is a favorite weekend getaway for families, couples, and adventure seekers looking to relax amidst nature."
  },
  {
    title: "Della Adventure Park",
    description: "Della Adventure Park is India's premier adventure destination offering a wide range of activities including zip-lining, ATV rides, bungee jumping, paintball, and luxury resort experiences. It is perfect for corporate outings, family vacations, and thrill seekers."
  },
  {
    title: "Lion's Point",
    description: "Lion's Point is a scenic hilltop viewpoint offering magnificent views of valleys, waterfalls, clouds, and winding mountain roads. It is one of the best places in Lonavala to enjoy cool weather, local snacks, and breathtaking natural landscapes."
  },
  {
    title: "Kune Waterfalls",
    description: "Kune Waterfalls is one of the highest waterfalls in Maharashtra, cascading beautifully through lush green hills near Lonavala. The serene surroundings, picturesque scenery, and refreshing atmosphere make it a popular destination for sightseeing and photography."
  }
],



"services": [
  {
    "name": "Mumbai to Lonavala Cab",
    "description": "Book Mumbai to Lonavala Cab for safe, comfortable, and reliable hill station travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for one way, round trip, family vacations, and weekend getaways."
  },
  {
    "name": "Mumbai to Lonavala Taxi",
    "description": "Hire Mumbai to Lonavala Taxi with experienced drivers, affordable fares, and comfortable AC vehicles for a smooth intercity journey."
  },
  {
    "name": "Mumbai to Lonavala Cab Package",
    "description": "Book Mumbai to Lonavala Cab Package with flexible travel plans, sightseeing options, and professional chauffeur service."
  },
  {
    "name": "Mumbai to Lonavala Taxi Price",
    "description": "Check Mumbai to Lonavala Taxi Price with transparent fares, affordable packages, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Lonavala Taxi Cost",
    "description": "Compare Mumbai to Lonavala Taxi Cost with budget-friendly pricing and premium travel comfort."
  },
  {
    "name": "Mumbai to Lonavala Car Rental",
    "description": "Choose Mumbai to Lonavala Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles for comfortable travel."
  },
  {
    "name": "Mumbai to Lonavala Cab Price",
    "description": "Get Mumbai to Lonavala Cab Price with competitive rates and flexible one way or round trip booking options."
  },
  {
    "name": "Mumbai to Lonavala Car Rental Price",
    "description": "Book Mumbai to Lonavala Car Rental Price packages with affordable fares and premium chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Lonavala Cab Booking",
    "description": "Complete Mumbai to Lonavala Cab Booking online with instant confirmation and multiple vehicle choices."
  },
  {
    "name": "Mumbai to Lonavala Cab for 2 Days",
    "description": "Reserve Mumbai to Lonavala Cab for 2 Days with customized sightseeing plans and comfortable chauffeur-driven travel."
  },
  {
    "name": "Mumbai Airport to Lonavala Taxi Fare",
    "description": "Check Mumbai Airport to Lonavala Taxi Fare with transparent pricing and convenient airport pickup services."
  },
  {
    "name": "Mumbai Airport to Lonavala Taxi",
    "description": "Book Mumbai Airport to Lonavala Taxi with direct airport pickup, experienced chauffeurs, and comfortable AC vehicles."
  },
  {
    "name": "Mumbai Central to Lonavala Taxi Fare",
    "description": "Choose Mumbai Central to Lonavala Taxi Fare with affordable pricing and reliable transportation."
  },
  {
    "name": "Mumbai Lonavala Cab Service",
    "description": "Hire Mumbai Lonavala Cab Service with professional drivers, clean vehicles, and flexible travel schedules."
  },
  {
    "name": "Mumbai Lonavala Car",
    "description": "Book Mumbai Lonavala Car with premium chauffeur-driven vehicles for family trips and holiday travel."
  },
  {
    "name": "Mumbai Lonavala Taxi Fare",
    "description": "Get Mumbai Lonavala Taxi Fare with competitive pricing, quality service, and no hidden charges."
  },
  {
    "name": "Mumbai to Lonavala Cab Booking Price",
    "description": "Compare Mumbai to Lonavala Cab Booking Price with affordable packages and premium travel comfort."
  },
  {
    "name": "Mumbai to Lonavala Cab Charges",
    "description": "Check Mumbai to Lonavala Cab Charges with transparent pricing and flexible travel plans."
  },
  {
    "name": "Mumbai to Lonavala Return Cab",
    "description": "Reserve Mumbai to Lonavala Return Cab with convenient round trip packages and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Lonavala Taxi Round Trip",
    "description": "Book Mumbai to Lonavala Taxi Round Trip for comfortable return travel with affordable packages."
  },
  {
    "name": "Mumbai to Lonavala Taxi One Way",
    "description": "Choose Mumbai to Lonavala Taxi One Way for economical single-trip travel without return charges."
  },
  {
    "name": "Panvel to Lonavala Cab",
    "description": "Book Panvel to Lonavala Cab with comfortable AC vehicles and reliable chauffeur service."
  },
  {
    "name": "Taxi Service Mumbai to Lonavala",
    "description": "Hire Taxi Service Mumbai to Lonavala with professional drivers, clean vehicles, and flexible booking options."
  },
  {
    "name": "Thane to Lonavala Cab Fare",
    "description": "Check Thane to Lonavala Cab Fare with affordable pricing and quality chauffeur-driven travel."
  },
  {
    "name": "Thane to Lonavala Cab",
    "description": "Reserve Thane to Lonavala Cab with comfortable vehicles and experienced drivers for hassle-free travel."
  },
  {
    "name": "Vashi to Lonavala Taxi Fare",
    "description": "Book Vashi to Lonavala Taxi Fare packages with transparent pricing and reliable transportation."
  },
  {
    "name": "Cab from Mumbai Airport to Lonavala",
    "description": "Choose Cab from Mumbai Airport to Lonavala with direct airport pickup and comfortable chauffeur-driven travel."
  },
  {
    "name": "Mumbai Airport to Lonavala Taxi",
    "description": "Hire Mumbai Airport to Lonavala Taxi with punctual airport transfers and premium vehicles."
  },
  {
    "name": "Navi Mumbai to Lonavala Cab",
    "description": "Book Navi Mumbai to Lonavala Cab with affordable fares and comfortable outstation travel."
  },
  {
    "name": "Thane to Lonavala Cab",
    "description": "Choose Thane to Lonavala Cab for safe, reliable, and convenient hill station transportation."
  },
  {
    "name": "Borivali to Lonavala Cab",
    "description": "Reserve Borivali to Lonavala Cab with experienced chauffeurs and premium AC vehicles."
  },
  {
    "name": "Andheri to Lonavala Cab",
    "description": "Book Andheri to Lonavala Cab with flexible pickup options and comfortable long-distance travel."
  },
  {
    "name": "Dadar to Lonavala Taxi",
    "description": "Hire Dadar to Lonavala Taxi with affordable pricing and professional chauffeur service."
  },
  {
    "name": "Bandra to Lonavala Cab",
    "description": "Choose Bandra to Lonavala Cab with reliable drivers and clean AC vehicles for family travel."
  },
  {
    "name": "Panvel to Lonavala Cab",
    "description": "Reserve Panvel to Lonavala Cab with premium comfort and affordable travel packages."
  },
  {
    "name": "CST to Lonavala Taxi",
    "description": "Book CST to Lonavala Taxi with convenient pickup, experienced drivers, and comfortable travel."
  },
  {
    "name": "Innova Crysta Mumbai to Lonavala",
    "description": "Hire Innova Crysta Mumbai to Lonavala for luxury family travel with spacious seating and premium comfort."
  }
],
"tableData": [
  ["Mumbai to Lonavala Cab", "Mumbai to Lonavala Taxi"],
  ["Mumbai to Lonavala Cab Package", "Mumbai to Lonavala Taxi Price"],
  ["Mumbai to Lonavala Taxi Cost", "Mumbai to Lonavala Car Rental"],
  ["Mumbai to Lonavala Cab Price", "Mumbai to Lonavala Car Rental Price"],
  ["Mumbai to Lonavala Cab Booking", "Mumbai to Lonavala Cab for 2 Days"],
  ["Mumbai Airport to Lonavala Taxi Fare", "Mumbai Airport to Lonavala Taxi"],
  ["Mumbai Central to Lonavala Taxi Fare", "Mumbai Lonavala Cab Service"],
  ["Mumbai Lonavala Car", "Mumbai Lonavala Taxi Fare"],
  ["Mumbai to Lonavala Cab Booking Price", "Mumbai to Lonavala Cab Charges"],
  ["Mumbai to Lonavala Return Cab", "Mumbai to Lonavala Taxi Round Trip"],
  ["Mumbai to Lonavala Taxi One Way", "Panvel to Lonavala Cab"],
  ["Taxi Service Mumbai to Lonavala", "Thane to Lonavala Cab Fare"],
  ["Thane to Lonavala Cab", "Vashi to Lonavala Taxi Fare"],
  ["Cab from Mumbai Airport to Lonavala", "Navi Mumbai to Lonavala Cab"],
  ["Borivali to Lonavala Cab", "Andheri to Lonavala Cab"],
  ["Dadar to Lonavala Taxi", "Bandra to Lonavala Cab"],
  ["CST to Lonavala Taxi", "Innova Crysta Mumbai to Lonavala"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Lonavala Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels provides reliable Mumbai to Lonavala cab services with clean, well-maintained vehicles and experienced drivers, making every journey comfortable for families, couples, and corporate travellers."
  },
  {
    WhyChooseheading: "Perfect for Weekend Getaways",
    WhyChoosedescription: "Whether you're planning a relaxing weekend, monsoon holiday, family picnic, honeymoon, or a one-day sightseeing trip, our Mumbai to Lonavala taxis offer a convenient and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles to match your group size, luggage, and comfort requirements."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Same-Day Return",
    WhyChoosedescription: "Book a one-way cab, round-trip taxi, or same-day return package with flexible pickup and drop timings according to your travel plans."
  },
  {
    WhyChooseheading: "Professional Drivers for Ghat Roads",
    WhyChoosedescription: "Our experienced chauffeurs are familiar with the Mumbai–Lonavala Expressway and ghat routes, ensuring a safe, smooth, and enjoyable drive."
  },
  {
    WhyChooseheading: "Customized Lonavala Sightseeing",
    WhyChoosedescription: "Enhance your trip by visiting popular attractions such as Tiger Point, Bhushi Dam, Lion's Point, Karla Caves, Bhaja Caves, Rajmachi Point, and Pawna Lake with a customized itinerary."
  },
  {
    WhyChooseheading: "Clean & Spacious Travel Experience",
    WhyChoosedescription: "Every cab is regularly serviced and offers comfortable seating, air conditioning, and ample luggage space for a relaxing journey to Lonavala."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Book your Mumbai to Lonavala cab quickly with transparent pricing, instant booking confirmation, and dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Lonavala Cab Service?",
    answer: "Yes, we provide Mumbai to Lonavala cab services for one-way trips, round trips, sightseeing tours, and weekend getaways."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Lonavala?",
    answer: "Yes, one-way taxi services are available with pickup from any location in Mumbai."
  },
  {
    question: "Which vehicles are available for Mumbai to Lonavala travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a same-day return cab?",
    answer: "Yes, same-day return and round-trip taxi packages are available according to your travel schedule."
  },
  {
    question: "Is the cab suitable for family and group trips?",
    answer: "Yes, our spacious vehicles are ideal for families, friends, couples, senior citizens, and corporate groups."
  },
  {
    question: "Can I include sightseeing in Lonavala?",
    answer: "Yes, you can customize your trip to include Bhushi Dam, Tiger Point, Lion's Point, Karla Caves, Bhaja Caves, Pawna Lake, and other nearby attractions."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, permits, and other applicable charges depend on the selected package and are clearly explained before booking."
  },
  {
    question: "Is Mumbai to Lonavala cab service available every day?",
    answer: "Yes, Shreesha Tours & Travels offers daily cab booking services based on advance reservations and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Lonavala Cab?",
    answer: "Share your pickup location, travel date, passenger details, preferred vehicle, and trip type to receive a quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Mehta",
    feedback: "Our Mumbai to Lonavala trip with Shreesha Tours & Travels was wonderful. The car was clean, the driver was polite, and we enjoyed a comfortable journey with sightseeing stops.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Riya Kulkarni",
    feedback: "We booked an Innova Crysta for a family weekend getaway to Lonavala. The service was punctual, the vehicle was spacious, and the entire trip was relaxing and enjoyable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lonavala Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-lonavala-cab.webp",
  "description":
    "Book Mumbai to Lonavala Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Lonavala with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for weekend getaways, family vacations, sightseeing tours, corporate travel, and airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-lonavala-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Mumbai to Lonavala Cab | Weekend Getaway Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Lonavala Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Lonavala with 24x7 online cab booking, transparent fares, and comfortable rides."
  />

  <meta
    name="keywords"
    content="Mumbai to Lonavala Cab, Mumbai to Lonavala Taxi, Mumbai to Lonavala Cab Package, Mumbai to Lonavala Taxi Price, Mumbai to Lonavala Taxi Cost, Mumbai to Lonavala Car Rental, Mumbai to Lonavala Cab Price, Mumbai to Lonavala Car Rental Price, Mumbai to Lonavala Cab Booking, Mumbai to Lonavala Cab for 2 Days, Mumbai Airport to Lonavala Cab, Mumbai Airport to Lonavala Taxi, Mumbai to Lonavala One Way Cab, Mumbai to Lonavala Round Trip Cab, Mumbai to Lonavala Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitolonavalacab;